module.exports = __webpack_public_path__ + "static/media/Apercu-Italic.619c2b66.otf";